import { render, staticRenderFns } from "./homeContentProduction.vue?vue&type=template&id=50982987&scoped=true&"
import script from "./homeContentProduction.vue?vue&type=script&lang=js&"
export * from "./homeContentProduction.vue?vue&type=script&lang=js&"
import style0 from "./homeContentProduction.vue?vue&type=style&index=0&id=50982987&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50982987",
  null
  
)

export default component.exports